import { GetterTree } from "vuex";
import { OcrState } from "./types";
import { RootState } from "@/store/types";

export const getters: GetterTree<OcrState, RootState> = {
  OcrState: (state: OcrState) => {
    return state;
  }
};
